<template>
  <div>
    <el-table :data="records" class="coin-table" :row-key="() => Math.random()">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="userId" label="封面图">
        <template slot-scope="scope">
          <img :src="scope.row.bannerImg" />
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述"> </el-table-column>
      <el-table-column prop="nodeName" label="节点名称"> </el-table-column>
      <el-table-column label="节点人数">
        <template slot-scope="scope">
          {{ scope.row.userCount }}
          <el-tooltip content="查看节点人数">
            <el-button
              type="info"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewPeople(scope.row.userId)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="weChatImage" label="二维码">
        <template slot-scope="scope">
          <img :src="scope.row.weChatImage" />
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="removeNote(scope.row.id)"
            >删除</el-button
          >
          <el-button type="primary" size="small" @click="chageNode(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
    <node-person @refresh="handleCurrentChange({ page: 1 })"></node-person>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';
import NodePerson from '../nodePeople';
import SortableMixin from 'mixins/SortableMixin';

export default {
  name: 'setnode',
  mixins: [SortableMixin],
  data() {
    return {
      sortable: '.coin-table'
    };
  },
  computed: {
    ...mapState('setnode', ['totalCount', 'pagination', 'records'])
  },
  components: {
    Pagination,
    Detail,
    NodePerson
  },
  methods: {
    ...mapMutations('setnode', [
      'setpage',
      'setEditingProject',
      'seeNodePeople'
    ]),
    ...mapActions('setnode', ['removeNode', 'Newpeople', 'setsort']),
    handleCurrentChange(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    },
    removeNote(id) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.removeNode({ nodeId: id }).then(() => {
            this.$message.success('操作成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    chageNode(project) {
      this.setEditingProject(project);
    },
    viewPeople(id) {
      this.seeNodePeople(id);
      this.Newpeople({ nodeId: id });
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;
      const { page, size } = this.pagination;
      if (oldIndex !== newIndex) {
        const nodeId = this.records[oldIndex].id;
        const fromNum = this.records[oldIndex].sort;
        const toNum = this.records[(page - 1) * size + newIndex].sort;
        this.setsort({
          nodeId: nodeId,
          fromNum: fromNum,
          toNum: toNum
        }).then(() => {
          this.$message.success('更新成功！');
          this.$emit('refresh');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
img {
  max-height: 70px;
}
</style>
